export const extractHashtags = (text: string) => {
  const result = text.match(/#[^\s#]*/gmi)
  if (result) {
    return result.filter(h => h !== '#')
  }
  return []
}